// extracted by mini-css-extract-plugin
export default {"root":"g_4sSVqwhr","root_coloredHeader":"RxoY3aO8l9","root_iconOnly":"mu3vh6_LjR"};